<template>
  <div id="app">
      <router-view></router-view>
    <globaluploader />
  </div>
</template>

<script>
import globaluploader from "./components/GlobalUploader";
export default {
  name: "App",
  components: {
    globaluploader
  }
};
</script>

<style>
#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.root_page {
  display: flex;
  flex-direction: column;
}
.table_wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.page_wrapper {
  flex: 0 0 34px;
  height: 34px;
  text-align: center;
}
.ctrl-wrapper {
  flex: 0 0 36px;
  height: 36px;
  display: flex;
  flex-direction: row;
  line-height: 36px;
}
.ctrl-wrapper .add_item {
  display: inline-block;
  flex: 0 0 90px;
  width: 90px;
  height: 36px;
  font-size: 16px;
}
.ctrl-wrapper .search_wrapper {
  flex: 1;
  text-align: right;
}
.common_search_wrapper .search-ipt {
  display: inline-table;
  width: 200px;
  text-align: left;
}
.main_table {
  flex: 1;
  margin: 15px 0 25px;
}
.jump_color {
  padding: 15px 10px 15px 0;
  color: #2d8cf0 !important;
  font-size: 16px;
  cursor: pointer;
}
.search_time .time {
  width: 49%;
}
.ivu-table-tbody .fly-blue {
  color: #2d8cf0;
  cursor: pointer;
}

.model_item {
  display: flex;
  margin-bottom: 15px;
}
.model_item .label {
  flex: 0 0 100px;
  width: 100px;
  margin-right: 10px;
  text-align: right;
  line-height: 30px;
}
.model_item .model_value {
  flex: 1;
  line-height: 30px;
  width: calc(100% - 110px);
}
.footer_ctrl {
  text-align: center;
}
.footer_ctrl .footer_btn_item {
  padding: 3px 52px;
  font-size: 14px;
}
.viewer-canvas {
  background: #fff;
}

.modal_item_wrapper {
  display: flex;
  margin-bottom: 10px;
}

.modal_item_wrapper .modal_label {
  display: inline-block;
  width: 70px;
  height: 32px;
  margin-right: 10px;
  line-height: 32px;
  text-align: right;
  font-size: 14px;
}

.modal_item_wrapper .item_context {
  flex: 1;
}
.home_nav{
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue